Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var reactFeather = require('react-feather');
var core = require('@material-ui/core');
var pickers = require('@material-ui/pickers');
var dateFns = require('date-fns');
var BaseModal = require('@ds-developer/modal');
var frontend = require('@ds-developer/frontend');
var RadioButtons = require('@ds-developer/radio-buttons');
var pluralize = require('pluralize');
var yup = require('yup');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var BaseModal__default = /*#__PURE__*/_interopDefaultLegacy(BaseModal);
var RadioButtons__default = /*#__PURE__*/_interopDefaultLegacy(RadioButtons);
var pluralize__default = /*#__PURE__*/_interopDefaultLegacy(pluralize);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
(function (TestStatus) {
  TestStatus["Passed"] = "Passed";
  TestStatus["Failed"] = "Failed";
  TestStatus["Cancelled"] = "Cancelled";
  TestStatus["Upcoming"] = "Upcoming";
  TestStatus["Pending"] = "Pending";
})(exports.TestStatus || (exports.TestStatus = {}));
(function (TestType) {
  TestType["Theory"] = "Theory";
  TestType["Practical"] = "Practical";
  TestType["Dit1"] = "DIT1";
  TestType["Dit2"] = "DIT2";
  TestType["Dit3"] = "DIT3";
})(exports.TestType || (exports.TestType = {}));
(function (PersonType) {
  PersonType["Dit"] = "DIT";
  PersonType["Instructor"] = "Instructor";
  PersonType["Learner"] = "Learner";
  PersonType["Motability"] = "Motability";
})(exports.PersonType || (exports.PersonType = {}));
var _a;
var upcomingDate = function upcomingDate(date) {
  if (!date) return false;
  var testDate = typeof date === "string" ? dateFns.parseISO(date) : date;
  var today = new Date(Date.now());
  return dateFns.isBefore(today, testDate);
};
var pastDate = function pastDate(date) {
  if (!date) return false;
  var testDate = typeof date === "string" ? dateFns.parseISO(date) : date;
  var today = new Date(Date.now());
  return dateFns.isAfter(today, testDate);
};
var statusMap = (_a = {}, _a[exports.TestStatus.Passed] = "Pass", _a[exports.TestStatus.Failed] = "Fail", _a[exports.TestStatus.Cancelled] = "Cancelled", _a[exports.TestStatus.Pending] = "Pending", _a);
/**
 * Return a user friendly status string
 * @param status
 */
var mapStatus = function mapStatus(status) {
  return statusMap[status];
};
/**
 * Returns deadline in days
 *
 * Could use date-fns formatDifferenceStrict with options.unit = "day"
 * but I don't think 0 days looks very nice
 * @param date
 */
var deadline = function deadline(date) {
  var diffDays = dateFns.differenceInDays(dateFns.startOfDay(new Date(date)), dateFns.startOfDay(new Date(Date.now())));
  if (diffDays === 0) {
    return "Today";
  }
  return diffDays + " " + pluralize__default['default']("day", diffDays);
};
/**
 * Get expected string representing status of test
 */
var getStatus = function getStatus(_a) {
  var date = _a.date,
    status = _a.status;
  if (status === "Upcoming") {
    return deadline(date);
  }
  return mapStatus(status);
};
var isDitTest = function isDitTest(testType) {
  return testType === exports.TestType.Dit1 || testType === exports.TestType.Dit2 || testType === exports.TestType.Dit3;
};
var isDitLearner = function isDitLearner(personType) {
  return personType === exports.PersonType.Dit;
};
var testTypeToString = function testTypeToString(testType) {
  switch (testType) {
    case exports.TestType.Dit1:
      return "Theory";
    case exports.TestType.Dit2:
      return "Practical";
    case exports.TestType.Dit3:
      return "Instructional";
    default:
      return testType.toString();
  }
};
var testSchema = yup.object().shape({
  id: yup.string(),
  type: yup.string().required(),
  date: yup.date().required(),
  status: yup.string().required()
});
var useClasses = core.makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      flexWrap: "wrap"
    },
    formInput: {
      margin: theme.spacing(1, 0),
      padding: theme.spacing(0)
    },
    deleteButton: {
      marginRight: "auto"
    },
    datePicker: {
      "& label": {
        fontSize: "16px",
        marginBottom: theme.spacing(1),
        color: "#000"
      }
    },
    datePickerInput: {
      paddingRight: 0
    },
    testTypeDisplayNone: {
      display: "none"
    }
  };
});
var TestDetailsModal = function TestDetailsModal(_a) {
  var _b = _a.test,
    test = _b === void 0 ? {} : _b,
    _c = _a.types,
    types = _c === void 0 ? ["Theory", "Practical"] : _c,
    _d = _a.onClose,
    onClose = _d === void 0 ? function () {} : _d,
    _e = _a.onChange,
    onChange = _e === void 0 ? function () {} : _e,
    _f = _a.onSubmit,
    onSubmit = _f === void 0 ? function () {} : _f,
    _g = _a.onDelete,
    onDelete = _g === void 0 ? function () {} : _g;
  var classes = useClasses();
  var _h = React.useState(test),
    testFormState = _h[0],
    setTestFormState = _h[1];
  var isEdit = Boolean(test.id);
  var disabled = test.editable === false;
  var title = isEdit ? "Edit a test date or result" : "Add a test date";
  var formIsValid = function formIsValid(form) {
    return testSchema.isValidSync(form);
  };
  var handleDelete = function handleDelete() {
    if (disabled) {
      return;
    }
    if (!formIsValid(testFormState)) {
      return;
    }
    if (!testFormState.id) {
      return;
    }
    onDelete(testFormState.id);
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    if (!formIsValid(testFormState)) {
      return;
    }
    if (disabled) {
      return;
    }
    onSubmit(testFormState);
  };
  var handleTestTypeChange = function handleTestTypeChange(type) {
    onChange(frontend.createFakeEvent("type", type));
    setTestFormState(_assign(_assign({}, testFormState), {
      type: type
    }));
  };
  var handleTestDateChange = function handleTestDateChange(newDate) {
    if (newDate && dateFns.isValid(newDate)) {
      var date = new Date(newDate);
      onChange(frontend.createFakeEvent("date", date));
      setTestFormState(_assign(_assign({}, testFormState), {
        date: date
      }));
    }
  };
  var handleTestStatusChange = function handleTestStatusChange(status) {
    onChange(frontend.createFakeEvent("status", status));
    setTestFormState(_assign(_assign({}, testFormState), {
      status: status
    }));
  };
  var actions = React__default['default'].createElement(React.Fragment, null, isEdit && React__default['default'].createElement(core.Button, {
    onClick: handleDelete,
    color: "default",
    startIcon: React__default['default'].createElement(reactFeather.Trash2, {
      size: 14
    }),
    className: classes.deleteButton,
    variant: "outlined",
    disabled: disabled,
    "data-test": "test-details-modal-delete-button"
  }, "Delete"), React__default['default'].createElement(core.Button, {
    onClick: onClose,
    color: "default",
    variant: "outlined"
  }, "Cancel"), React__default['default'].createElement(core.Button, {
    type: "submit",
    form: "editTestDialogForm",
    color: "primary",
    variant: "contained",
    disabled: !formIsValid(testFormState) || disabled,
    "data-test": "test-details-modal-save-button"
  }, "Save"));
  return React__default['default'].createElement(BaseModal__default['default'], {
    actions: actions,
    title: title,
    testId: "learner-test-edit-modal",
    open: true
  }, React__default['default'].createElement("form", {
    id: "editTestDialogForm",
    onSubmit: handleSubmit,
    className: classes.container
  }, React__default['default'].createElement(core.Container, {
    className: classes.formInput
  }, React__default['default'].createElement(RadioButtons__default['default'], {
    label: "Test Type",
    value: testFormState.type,
    onChange: handleTestTypeChange,
    disabled: disabled
  }, Object.values(types).map(function (type, idx) {
    return React__default['default'].createElement(core.Button, {
      key: idx,
      value: type,
      "data-test": "test-details-modal-edit-type-button-" + type.toLowerCase().replace(/\s+/, "")
    }, isDitTest(type) ? testTypeToString(type) : type);
  }))), React__default['default'].createElement(core.Container, {
    className: classes.formInput
  }, React__default['default'].createElement(pickers.MuiPickersUtilsProvider, {
    utils: frontend.CustomDateFnsUtils
  }, React__default['default'].createElement(pickers.KeyboardDatePicker, {
    disableToolbar: true,
    variant: "inline",
    format: "dd/MM/yyyy",
    margin: "normal",
    id: "date-picker-inline",
    label: "Date",
    value: testFormState.date || null,
    onChange: handleTestDateChange,
    KeyboardButtonProps: {
      "aria-label": "change date"
    },
    className: classes.datePicker,
    InputProps: {
      className: classes.datePickerInput
    },
    keyboardIcon: React__default['default'].createElement(reactFeather.Calendar, {
      size: 20
    }),
    inputVariant: "outlined",
    disabled: disabled,
    "data-test": "test-details-modal-edit-date-field"
  }))), React__default['default'].createElement(core.Container, {
    className: classes.formInput
  }, React__default['default'].createElement(RadioButtons__default['default'], {
    label: "Test Status",
    value: testFormState.status,
    onChange: handleTestStatusChange,
    disabled: disabled
  }, ["Passed", "Failed", "Upcoming"].map(function (status, idx) {
    return React__default['default'].createElement(core.Button, {
      key: idx,
      value: status,
      disabled: upcomingDate(testFormState === null || testFormState === void 0 ? void 0 : testFormState.date) && status !== "Upcoming" || pastDate(testFormState === null || testFormState === void 0 ? void 0 : testFormState.date) && status === "Upcoming",
      "data-test": "test-details-modal-edit-status-button-" + status.toLowerCase()
    }, status);
  })))));
};
exports.deadline = deadline;
exports.default = TestDetailsModal;
exports.getStatus = getStatus;
exports.isDitLearner = isDitLearner;
exports.isDitTest = isDitTest;
exports.pastDate = pastDate;
exports.testTypeToString = testTypeToString;
exports.upcomingDate = upcomingDate;